export default {
  menu: {
    list: 'AI Agent List',
    edit: 'Edit AI Agent'
  },
  title: {
    aiAgentManagement: 'AI Agent Management'
  },
  label: {
    companyName: 'Company Name',
    agentName: 'Agent Name',
    modelName: 'Model Name',
    version: 'Version',
    updateTime: 'Update Time',
    temperature: 'Temperature',
    prompt: 'Prompt',
    agentDescription: 'Agent Description'
  }
}
